import React from "react";
import Icon from "components/Common/Icon";
import { EXPANSION, getFormattedContentType, SEASON } from "../../../lib/wowHelpers";
import { getWowStatic } from "hooks/wow/getStaticData";
import SubtitleAndDescription from "../../Common/SubtitleAndDescription";
import { getFormattedNames } from "../../../lib/wowHelpers";

// tierSet arrives from the builds payload (`tier_set` on the class file,
// keyed by spec — Common.TierSetData in the exodia backend owns the mapping).
const TierSetContainer = (props) => {
  const { className, specName, encounterType, tierSet } = props;
  const { displayClassName, displaySpecName } = getFormattedNames(className, specName);
  const twoPieceStaticData = getWowStatic("spell", tierSet?.two_piece);
  const fourPieceStaticData = getWowStatic("spell", tierSet?.four_piece);

  return twoPieceStaticData && fourPieceStaticData ? (
    <div className="tier-set-container">
      <div className="content-section">
        <SubtitleAndDescription
          subtitle={`${displaySpecName} ${encounterType === "PvP" ? "PvP " : ""}Tier Set`}
          description={`${EXPANSION} Season ${SEASON} ${displaySpecName} ${displayClassName} ${getFormattedContentType(
            encounterType,
          )} Tier Set`}
          className="tier-set-subtitle"
        />
        <div className="tier-set-content">
          <div className="text">
            <span className="title">2-Set</span> - <Icon staticDataImg={twoPieceStaticData.img} iconSize="20px" />{" "}
            {twoPieceStaticData.description}
          </div>
          <div className="text">
            <span className="title">4-Set</span> - <Icon staticDataImg={fourPieceStaticData.img} iconSize="20px" />{" "}
            {fourPieceStaticData.description}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default TierSetContainer;
